/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Link, browserHistory} from 'react-router';
import {bindActionCreators} from 'redux';
import EstablishmentsTable from '../EstablishmentsTable/EstablishmentsTable';
import EstablishmentsTableMobile from '../EstablishmentsTable/EstablishmentsTableMobile';
import {searchForFormById} from '../../../selectors/searchForForm';
import * as FormName from '../../../constants/formNameConstants';
import * as establishmentActions from '../../../actions/establishmentActions';
import * as accountActions from '../../../actions/accountActions';
import * as pathConsts from '../../../constants/pathConstants';
import '../../../styles/establishment/establishmentHeader.css';
import '../../../styles/establishment/establishmentDashboard.css';
import EstablishmentSubmitModal from '../EstablishmentSubmitModal';
import Button from '../../common/Button';
import {ITAAlert} from '../../common/ITAAlert';
import {createSubmitEstablishmentObject} from '../EstablishmentSubmissionObject';
import EstablishmentFilterRow from './EstablishmentFilterRow';
import EstablishmentsDashboardHeading from './EstablishmentsDashboardHeading';
import { generateSubmissionReport } from '../../../actions/generateSubmissionReport';
import EstablishmentBulkRemovalForm from '../EstablishmentBulkRemovalForm';

class EstablishmentsDashboardPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    let newFilterValues = Object.assign({}, this.props.filterValues);
    this.state = {
      establishmentsToSubmitMap: {},
      establishmentsToSubmit: [],
      numOfEstablishments: '0',
      pageSize: props.pageSize,
      submitValues: Object.assign({}, this.props.submitValues),
      filterValues: this.props.filterValues,
      newFilterValues,
      filteredEstablishments: Object.assign({}, this.props.filteredEstablishments),
      filtersSetPreviously: this.props.filtersSetPreviously,
      resubmissionReason: '',
      showModal: false,
      showRemovalModal: false,
      submitAll: false,
      isResubmit: false,
      isActive: true,
      isDocked: false,
      message: '',
      currentPage: 1,
      filingYear: new Date().getFullYear()-1,
      fullyExcludedStates: '',
      partiallyExcludedStates: '',
      removalAgreement: false
    };

    this.selectAll = this.selectAll.bind(this);
    this.dockButton = this.dockButton.bind(this);
    this.clickSelectEstablishment = this.clickSelectEstablishment.bind(this);
    this.submitEstablishments = this.submitEstablishments.bind(this);
    this.showSubmitPage = this.showSubmitPage.bind(this);
    this.hideSubmitPage = this.hideSubmitPage.bind(this);
    this.hideRemovalPage = this.hideRemovalPage.bind(this);
    this.enteringResubmissionReason = this.enteringResubmissionReason.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRemovalClick = this.handleRemovalClick.bind(this);
    this.selectEstablishment = this.selectEstablishment.bind(this);
    this.removeSelectedEstablishments = this.removeSelectedEstablishments.bind(this);
    this.toggleInactive = this.toggleInactive.bind(this);
    this.redirect = this.redirect.bind(this);
    this.handleCreateEstablishmentClick = this.handleCreateEstablishmentClick.bind(this);
    this.enteringDataFilter = this.enteringDataFilter.bind(this);
    this.onSelectFilter = this.onSelectFilter.bind(this);
    this.filterEstablishments = this.filterEstablishments.bind(this);
    this.setFilters = this.setFilters.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.changePageSize = this.changePageSize .bind(this);
  }

  componentDidMount() {
    if (this.props.establishments.length === 0) {
      this.props.accountActions.getAllEstablishments();
    }
    window.addEventListener('scroll', this.dockButton);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({filteredEstablishments: nextProps.filteredEstablishments});
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.dockButton);
    this.props.actions.clearFrontPageFilter();
  }

  dockButton() {
    let {isDocked} = this.state;
    this.refs["submitMobileAnchor"].getBoundingClientRect().bottom < 0
      ? !isDocked && this.setState({isDocked: true})
      : isDocked && this.setState({isDocked: false});
  }

  submitEstablishments(event) {
    event.preventDefault();

    const filingYear = this.state.filingYear;
    const establishments = this.state.establishmentsToSubmit;
    const resubmissionReason = this.state.resubmissionReason;
    const establishmentsToSubmit = establishments.map(establishment => {
      return createSubmitEstablishmentObject(establishment, filingYear, resubmissionReason);
    });
    let date = new Date();
    let countSubmitted = establishmentsToSubmit.length;
    let message = (<ITAAlert
      style="success"
      message={<div> <div className="first-line">
      On {date.toLocaleDateString()}
      {} at {date.toLocaleTimeString()}, you have successfully submitted {countSubmitted}
      {} establishment(s) to OSHA.
    </div>An email confirmation will be sent shortly. </div>}/>);
    this.hideSubmitPage();
    this.props.actions.submitEstablishments(establishmentsToSubmit)
      .then(response => {
        if (response) {
          this.setState({
            message: message,
            resubmissionReason: "",
            establishmentsToSubmit: [],
            establishmentsToSubmitMap: {}
          });
          this.redirect(pathConsts.pathToEstablishmentsDashboardPage);
        }
      })
      .catch(error => {
        this.hideSubmitPage();
        throw(error);
      });
    this.setState({
      submitAll: false,
    }, function () {
      this.forceUpdate();
    });
  }

  removeSelectedEstablishments(event) {
    const selectedIds = this.state.establishmentsToSubmit.map(establishment => establishment.id);
    this.props.actions.bulkRemoveEstablishments(selectedIds, this.props.user.email);
  }

  showSubmitPage() {
    const isResubmit = setResubmit(this.state.establishmentsToSubmit, this.state.filingYear);
    this.setState({
      showModal: true,
      isResubmit: isResubmit
    });
  }

  hideSubmitPage() {
    let submitValues = this.state.submitValues;
    submitValues['resubmissionReason'] = '';
    submitValues['agreementSubmit'] = '0';
    let isActive = true;
    this.setState({
      submitValues: submitValues,
      isActive: isActive,
      showModal: false
    });
  }

  hideRemovalPage() {
    this.setState({
      showRemovalModal: false,
      removalAgreement: false
    });
  }

  enteringResubmissionReason(event) {
    event.preventDefault();
    let resubmissionReason = event.target.value;
    this.setState({resubmissionReason: resubmissionReason});
  }

  handleClick(event) {
    let isActive = this.state.isActive;
    let submitValues = this.state.submitValues;
    if (submitValues['agreementSubmit'] === "1") {
      submitValues['agreementSubmit'] = "0";
      isActive = true;
    } else {
      submitValues['agreementSubmit'] = event.target.value;
      isActive = false;
    }
    this.setState({
      submitValues: submitValues,
      isActive: isActive,
    });
  }

  handleRemovalClick() {
    let agreement = this.state.removalAgreement;
    console.log(agreement);
    this.setState({
      removalAgreement: !agreement
    });
  }

  toggleInactive() {
    let filtersSetPreviously = this.state.filtersSetPreviously;
    let newFilterValues = this.state.newFilterValues;
    if (newFilterValues.establishment_status === '1') {
      newFilterValues.establishment_status = '2';
    } else {
      newFilterValues.establishment_status = '1';
    }
    this.setState({newFilterValues: newFilterValues});
    if (filtersSetPreviously === true) {
      this.props.actions.clearFrontPageFilter();
      this.setState({
        filteredEstablishments: [{}],
        filsterSetPreviously: false
      });
    }
  }

  selectAll() {
    let submitAll = this.state.submitAll;
    if (submitAll) {
      this.setState({
        establishmentsToSubmit: [],
        establishmentsToSubmitMap: {}
      });
    } else {
      const establishmentsToSelect = this
        .filterEstablishments(this.props.establishments)
        .filter(establishment => {
          if (!this.state.establishmentsToSubmitMap[establishment.id]) {
            return true;
          }
        });
      establishmentsToSelect.map(establishment => {
        this.selectEstablishment(establishment.id);
      });
    }
    this.setState({
      submitAll: !submitAll
    });
  }

  clickSelectEstablishment(event) {
    const id = event.target.value;
    this.selectEstablishment(id);
  }

  selectEstablishment(id) {
    let establishmentsToSubmitMap = this.state.establishmentsToSubmitMap;
    let establishmentsToSubmit = this.state.establishmentsToSubmit;
    if (!establishmentsToSubmitMap[id]) {
      const establishment = searchForEstablishmentById(this.filterEstablishments(this.props.establishments), id);
      console.log(establishment);
      establishmentsToSubmitMap[id] = establishment;
      establishmentsToSubmit.push(establishment);
    } else {
      establishmentsToSubmitMap[id] = null;
      establishmentsToSubmit = [...establishmentsToSubmit.filter(establishment => establishment.id != id)];
    }
    this.setState({
      establishmentsToSubmitMap: establishmentsToSubmitMap,
      establishmentsToSubmit: establishmentsToSubmit,
      numOfEstablishments: establishmentsToSubmit.length
    });
  }

  /*
   **  Pager specific code.  When reusing the pager, make sure to add a
   **  state variable called "currentPage" with a starting value of 1.
   **
   */
  getPage(establishments) {
    let start = this.state.pageSize * (this.state.currentPage - 1);
    let end = start + this.state.pageSize;
    let numPages = this.getNumPages(establishments);
    let establishmentsNum = establishments.length;
    establishments = establishments.slice(start, end);

    let estabLength = establishments.length;
    let currentEstablishmentsNum;
    if (estabLength == 1) {
      currentEstablishmentsNum = (start + 1);
    } else {
      currentEstablishmentsNum = (start + 1) + " - " + (start + estabLength);
    }

    return {
      currentPage: this.state.currentPage,
      currentEstablishmentsNum,
      establishments,
      establishmentsNum,
      numPages,
      handlePagerClick: function (pageNum) {
        return function () {
          window.scrollBy(0, this.refs["submitMobileAnchor"].getBoundingClientRect().top);
          this.handlePageChange(pageNum);
        }.bind(this);
      }.bind(this)
    };
  }

  getNumPages(establishments) {
    let numPages = Math.floor(establishments.length / this.state.pageSize);
    if (establishments.length % this.state.pageSize > 0) {
      numPages++;
    }
    return numPages;
  }

  handlePageChange(pageNum) {
    this.setState({currentPage: pageNum});
  }

  redirect(path) {
    browserHistory.push(path);
  }

  handleCreateEstablishmentClick(event) {
    event.preventDefault();
    const path = event.target.name;
    this.redirect(path);
  }

  changePageSize(event) {
    event.preventDefault();
    this.setState({
      pageSize: parseInt(event.target.value)
    });
    this.setState({currentPage: 1});
    window.scrollBy(0, this.refs["submitMobileAnchor"].getBoundingClientRect().top);
  }

  pager(page) {
    return (
      <div className="pager">
        <div className="establishment-number col-sm-4 col-xs-6 text-left-md">
          Results {page.currentEstablishmentsNum} of {page.establishmentsNum}
        </div>
        <div className="page-size-selector col-sm-4 col-xs-6 text-right-md pull-right">
          <select className="" onChange={this.changePageSize}>
            <option value={20}>Show 20 per page</option>
            <option value={50}>Show 50 per page</option>
            <option value={100}>Show 100 per page</option>
            <option value={250}>Show 250 per page</option>
          </select>

        </div>
        <div className="pager-buttons col-sm-4 col-xs-12">
          <button
            className={"pageLink first " + ((page.currentPage <= 2) ? "disabled" : "")}
            onClick={page.handlePagerClick(1)}
            disabled={page.currentPage <= 2}>«
          </button>
          <button
            className={"pageLink previous " + ((page.currentPage == 1) ? "disabled" : "")}
            onClick={page.handlePagerClick(page.currentPage - 1)}
            disabled={page.currentPage == 1}>‹
          </button>
          <span className="currentPage">Page {page.currentPage} of {page.numPages}</span>
          <button
            className={"pageLink next " + ((page.currentPage > (page.numPages - 1))
            ? "disabled" : "")}
            onClick={page.handlePagerClick(page.currentPage + 1)}
            disabled={page.currentPage > (page.numPages - 1)}>›
          </button>
          <button
            className={"pageLink last " + ((page.currentPage >= (page.numPages - 1))
            ? "disabled" : "")}
            onClick={page.handlePagerClick(page.numPages)}
            disabled={page.currentPage >= (page.numPages - 1)}>»
          </button>
        </div>

      </div>
    );
  }

  /*
   **  End pager code
   */
  /**
   *
   * Filter Functionality
   */

  enteringDataFilter(event) {
    event.preventDefault();
    const field = event.target.name;
    let newFilterValues = this.state.newFilterValues;
    if (field === "zipcode") {
      newFilterValues[field] = handleZip(newFilterValues.zipcode, event.target.value);
    } else {
      newFilterValues[field] = event.target.value;
    }
    this.setState({newFilterValues: newFilterValues});
  }

  onSelectFilter(event) {
    event.preventDefault();
    const field = event.target.name;
    let newFilterValues = this.state.newFilterValues;
    newFilterValues[field] = event.target.value;
    this.setState({newFilterValues: newFilterValues});
  }

  setFilters(event) {
    event.preventDefault();
    let filtersSetPreviously = this.state.filtersSetPreviously;
    let filterValues;
    let newFilterValues = this.state.newFilterValues;
    if (filtersSetPreviously === true) {
      this.props.actions.clearFrontPageFilter();
      this.setState({
        filteredEstablishments: [{}],
        filtersSetPreviously: false
      });
    }
    filterValues = Object.assign({}, newFilterValues);
    this.setState({
      filterValues: filterValues,
      currentPage: 1
    });

  }

  filterEstablishments(establishments = this.props.establishments) {
    let filterValues = this.state.filterValues;

    if (filterValues['establishment_status'] === '1') {
      establishments = this.props.establishments
        .filter((establishment) => {
          return (establishment.establishment_status === 1);
        });
    }
    if (filterValues.zipcode !== '') {
      let zipcode = filterValues.zipcode.length > 5 ? filterValues.zipcode.slice(0, 5)
        + filterValues.zipcode.slice(6)
        : filterValues.zipcode;
      establishments = establishments.filter((establishment) => {
        return (establishment.address.zip.indexOf(zipcode) >= 0);
      });
    }
    if (filterValues.state !== '') {
      establishments = establishments.filter((establishment) => {
        return (establishment.address.state === filterValues.state);
      });
    }
    if (filterValues.submission_status !== '') {
      establishments = establishments.filter((establishment) => {
        return (establishment.submission_status == filterValues.submission_status);
      });
    }
    if (filterValues.address !== '') {
      establishments = establishments.filter((establishment) => {
        return (establishment.address.street.toLowerCase().indexOf(filterValues.address.toLowerCase()) >= 0
        || establishment.address.city.toLowerCase().indexOf(filterValues.address.toLowerCase()) >= 0
        || establishment.establishment_name.toLowerCase().indexOf(filterValues.address.toLowerCase()) >= 0);
      });
    }
    return establishments;
  }

  clearFilters() {
    let filterValues = this.state.filterValues;
    filterValues.address = '';
    filterValues.zipcode = '';
    filterValues.state = '';
    filterValues.submission_status = '';
    filterValues.establishment_status = '1';

    let establishments = this.props.establishments
      .filter((establishment) => {
        return (establishment.establishment_status === 1);
      });

    if (this.state.filtersSetPreviously === true) {
      this.props.actions.clearFrontPageFilter();
      this.setState({
        filteredEstablishments: [{}],
        fitlersSetPreviously: false
      });
    }
    this.setState({
      establishments: establishments,
      filterValues: filterValues,
      newFilterValues: Object.assign({}, filterValues)
    });
  }

  render() {
    let page;
    if (this.state.filteredEstablishments.length !== 0 &&
        typeof this.state.filteredEstablishments.length !== 'undefined'
        && this.state.filtersSetPreviously === true) {
      page = this.getPage(this.state.filteredEstablishments);
    } else if (this.state.filteredEstablishments.length === 0
      && this.state.filtersSetPreviously === true) {
      page = this.getPage(this.state.filteredEstablishments);
    } else {
      page = this.getPage(this.filterEstablishments(this.props.establishments));
    }
    let docked = this.state.isDocked ? " docked" : "";
    return (
      <div id="establishment-dashboard-page">
        <div>{this.state.message}</div>
        <EstablishmentsDashboardHeading/>
        <div id="establishment-dashboard">
          <div className="establishment-buttons-container non-mobile row">
            <Button
              onClick={this.handleCreateEstablishmentClick}
              name={pathConsts.pathToCreateEstablishmentPage}
              value="Create an Establishment"
              disabled={false}
              className={"btn btn-primary estab-btn"}
              id="create-estab-btn"
              title="Create an Establishment"/>
            <Button
              onClick={() => generateSubmissionReport()}
              value="View Submission Report"
              id="submission-report-btn"
              className={"btn btn-primary estab-btn"}
            />
          </div>
          <div className="anchor-holder">
            <EstablishmentFilterRow
              enteringData={this.enteringDataFilter}
              onSelect={this.onSelectFilter}
              setFilters={this.setFilters}
              clearFilters={this.clearFilters}
              newFilterValues={this.state.newFilterValues}
              toggleInactive={this.toggleInactive}/>

            <div className="submit-mobile-anchor" ref="submitMobileAnchor"/>
          </div>
          <div className={"submit-button-container mobile" + docked}>
            <input
              type="submit"
              value="Submit Data for Selected"
              className="btn btn-primary col-xs-12 submit-estab-btn"
              onClick={this.showSubmitPage}
              disabled={this.state.establishmentsToSubmit.length == 0}/>
            <Button
              onClick={this.handleCreateEstablishmentClick}
              name={pathConsts.pathToBulkTransferPage}
              value="Transfer Establishments from Another User"
              className={"btn btn-primary col-xs-12 submit-estab-btn"}
            />
          </div>
          <EstablishmentSubmitModal
            showModal={this.state.showModal}
            onHide={this.hideSubmitPage}
            submitForm={this.props.submitForm}
            isResubmit={this.state.isResubmit}
            isActive={this.state.isActive}
            numberOfEstablishments={this.state.numOfEstablishments}
            resubmissionReason={this.state.resubmissionReason}
            onSubmit={this.submitEstablishments}
            onClick={this.handleClick}
            onChange={this.enteringResubmissionReason}/>
          <EstablishmentBulkRemovalForm
            showModal={this.state.showRemovalModal}
            onRemove={this.removeSelectedEstablishments}
            establishments={this.state.establishmentsToSubmit}
            hideRemovePage={this.hideRemovalPage}
            removalAgreement={this.state.removalAgreement}
            onAgreement={this.handleRemovalClick}
          />
          {this.props.establishments.length == 0 ? <div>No establishments have been created.
              <Link to={pathConsts.pathToCreateEstablishmentPage}> Click here to get started.</Link>
            </div> : <div>
            <div className="first-line establishment-note">
                <div>Note: It may take up to 15 minutes for changes to take effect. To view the latest data, please refresh the page.</div>
                <Button
                  onClick={() => [this.setState({
                    showRemovalModal: true
                  })]}
                  value="Remove Establishment(s)"
                  className={"btn-cancel remove-selected-btn"}
                  id={"remove-establishment-btn"}
                  title="To remove establishments, select the boxes to the left of the Establishment List table"
                />
            </div>
            <EstablishmentsTable
              establishments={page.establishments}
              onSelect={this.clickSelectEstablishment}
              onSelectAll={this.selectAll}
              selectAllChecked={this.state.submitAll}
              selectedEstablishments={this.state.establishmentsToSubmitMap}
              hideStatus={false}/>
            <EstablishmentsTableMobile
              establishments={page.establishments}
              onSelect={this.clickSelectEstablishment}
              onSelectAll={this.selectAll}
              selectAllChecked={this.state.submitAll}
              selectedEstablishments={this.state.establishmentsToSubmitMap}
              hideStatus={false}/> {page.establishments.length !== 0 && this.pager(page)}
          </div>}
          <div className="establishment-buttons-container non-mobile row">
            <input
              type="submit"
              value="Submit Data for Selected"
              className="btn btn-primary col-md-3 col-sm-4 col-xs-12 pull-left submit-estab-btn"
              onClick={this.showSubmitPage}
              disabled={this.state.establishmentsToSubmit.length == 0}
              title="Submit Data for Selected"/>
          </div>
        </div>
      </div>
    );
  }
}

EstablishmentsDashboardPage.propTypes = {
  actions: PropTypes.object.isRequired,
  accountActions: PropTypes.object.isRequired,
  establishments: PropTypes.array.isRequired,
  filteredEstablishments: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  filtersSetPreviously: PropTypes.bool.isRequired,
  pageSize: PropTypes.number.isRequired,
  submitForm: PropTypes.object,
  submitValues: PropTypes.object.isRequired,
  filterValues: PropTypes.object.isRequired
};

function searchForEstablishmentById(establishments, id) {
  if (establishments && establishments.length > 0) {
    const establishment = establishments.filter(establishment => {
      return establishment.id == id;
    });
    if (establishment) {
      return establishment[0];
    }
  }
  return null;
}

function setResubmit(establishments, filingYear) {
  let isResubmit = false;
  establishments.map(establishment => {
    if (establishment.years_submitted) {
      if (establishment.years_submitted.indexOf(filingYear) >= 0) {
        isResubmit = true;
      }
    }
  });
  return isResubmit;
}

function mapStateToProps(state) {
  let establishments = state.establishments,
    filteredEstablishments = [],
    filterValues = {
      address: '',
      zipcode: '',
      state: '',
      establishment_status: '1',
      submission_status: ''
    };
  let filtersSetPreviously = false;

  if (state.frontPageFilter.length !== 0) {
    let frontPageFilter = state.frontPageFilter[0];
    filteredEstablishments = frontPageFilter.establishments;
    filterValues['submission_status'] = frontPageFilter.filter;
    filtersSetPreviously = true;
  }

  let submitValues = {
    resubmissionReason: '',
    agreementSubmit: '0'
  };

  let submitForm = {};
  if (state.forms.length > 0) {
    submitForm = searchForFormById(state.forms, FormName.itaSubmitModalId);
  }
  return {
    establishments: establishments,
    filteredEstablishments: filteredEstablishments,
    user: state.user[state.user.length - 1] || {},
    submitForm: submitForm,
    filtersSetPreviously: filtersSetPreviously,
    submitValues: submitValues,
    filterValues: filterValues,
    pageSize: 20
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(establishmentActions, dispatch),
    accountActions: bindActionCreators(accountActions, dispatch)
  };
}

function handleZip(zipSoFar, incomingZip) {
  if (incomingZip.length === 6 && incomingZip.slice(-1) !== "-") {
    incomingZip = zipSoFar + '-' + incomingZip.slice(-1);
  }
  if (incomingZip.length === 6 && incomingZip.slice(-1) === '-') {
    incomingZip = incomingZip.substring(0, incomingZip.length - 1);
  }
  if (incomingZip.length > 10) {
    return zipSoFar;
  }
  return incomingZip;
}
export default connect(mapStateToProps, mapDispatchToProps)(EstablishmentsDashboardPage);



/** WEBPACK FOOTER **
 ** ./src/components/establishment/establishmentsDashboard/EstablishmentsDashboardPage.js
 **/